export interface WalletDetails {
	type: "solana" | "ethereum";
	name: string;
	publicKey: string;
	privateKey: string;
}

export interface StoredData {
	mnemonic: string;
	wallets: WalletDetails[];
}

export const saveData = (currentMnemonic: string, wallets: WalletDetails[]) => {
	const data: StoredData = { mnemonic: currentMnemonic, wallets };
	localStorage.setItem("walletData", JSON.stringify(data));
};
